<template>
  <div class="main" v-show="$route.query.code">
    <div
      v-for="item in detail.detailList"
      :key="item.bookPackageDownloadResourceDetailId"
      class="detail_item"
    >
      <div class="info-title">
        <div class="top-wrapper">
          <img src="@/assets/books/zip-icon.png" alt="" />
          <div class="info">
            <p class="name ellipsis-2">
              {{ item.bookPackageDownloadResourceName }}
            </p>
          </div>
        </div>
        <div class="bottom-row">
          <div class="size" v-if="item.bookPackageDownloadSize">
            {{ formatSize(item.bookPackageDownloadSize) }}
          </div>
          <span
            v-if="!isFromMail"
            class="title-right"
            @click="toggleItem(item)"
          >
            <span v-if="item.isShow">收起</span>
            <span v-else>展开</span>
            <img
              class="title-icon"
              :class="{ overturn: item.isShow }"
              src="@/assets/books/down-icon-new.png"
              alt=""
            />
          </span>
        </div>
      </div>
      <div v-show="item.isShow">
        <div v-if="!isFromMail" class="method">
          <img src="@/assets/books/mail.png" alt="" class="bg-icon" />
          <p class="title">
            方法一：电子邮箱下载
            <span class="float-right" @click="showMethod2 = !showMethod2">
              帮助
              <img
                class="down-icon"
                :class="{ overturn: showMethod2 }"
                src="@/assets/books/down-icon-new.png"
                alt=""
              />
            </span>
          </p>
          <p class="desc">邮箱中点击链接下载</p>
          <div style="overflow: hidden;">
            <div class="tips" v-show="showMethod2">
              <p>
                <span class="primary-color">1.</span
                ><span>在下方输入邮箱地址，并点击发送</span>
              </p>
              <p>
                <span class="primary-color">2.</span><span>打开邮箱，</span
                ><span class="primary-color">点击链接进行下载</span>
              </p>
              <img src="@/assets/books/method2-new.png" alt="" />
            </div>
          </div>
          <c-input btn-type="send" class="input" @send="send(item, $event)" />
          <p class="msg">
            网易邮箱存在误判为垃圾邮件问题，请尽量不要使用163、126等邮箱
          </p>
        </div>
        <div class="method">
          <img src="@/assets/books/browser.png" alt="" class="bg-icon" />
          <p class="title">
            <span v-if="!isFromMail">方法二：</span>浏览器下载
            <span class="float-right" @click="showMethod1 = !showMethod1">
              帮助
              <img
                class="down-icon"
                :class="{ overturn: showMethod1 }"
                src="../../assets/books/down-icon-new.png"
                alt=""
              />
            </span>
          </p>
          <p class="desc">点击复制链接，粘贴到浏览器地址栏下载</p>
          <div style="overflow: hidden;">
            <div class="tips" v-show="showMethod1">
              <p>
                <span class="primary-color">1.点击下方复制按钮</span
                ><span>，将手机上复制的网址发送到电脑上</span>
              </p>
              <p>
                <span class="primary-color">2.</span
                ><span>在电脑上打开浏览器，</span
                ><span class="primary-color">粘贴</span
                ><span>刚刚复制的网址</span>
              </p>
              <img src="../../assets/books/method1.png" alt="" />
            </div>
          </div>
          <c-input
            class="input"
            @copy="copy"
            :url="item.resourceUrl"
            :btn-style="isFromMail ? 'secondary' : 'primary'"
          />
          <p
            class="down_new"
            :class="{ mail: isFromMail, normal: !isFromMail }"
            @click="downLoadUrl(item.resourceUrl)"
          >
            点此立即下载
          </p>
        </div>
      </div>
    </div>
    <div class="follow">
      <div>
        <img class="logo" src="@/assets/books/logo-new.png" />
        <h3>获取更多优质教学资源</h3>
        <p>请长按关注公众号“新教育智能平台”</p>
      </div>
      <div>
        <img class="qrcode" src="@/assets/books/qrcodeNewUI.png" alt="" />
      </div>
    </div>
    <c-modal ref="modal"></c-modal>
  </div>
</template>

<script>
import { toast, formatSize, loading, closeLoading } from '../../lib/utils';
import CInput from './components/Input';
import CModal from './components/Modal';
import booksResourceApi from '@/apis/booksResource';
import api from '@/apis/api';
import { decryptByAES } from '@/lib/security';
import { setclientSessionId } from '@/lib/utils';
import md5 from 'js-md5';
export default {
  components: { CInput, CModal },
  data() {
    return {
      showMethod1: false,
      showMethod2: false,
      detail: {},
      // location: window.location,
      isFromMail: false,
    };
  },
  async mounted() {
    await this.setSafeCode();
    if (this.$route.query.qr) {
      // 证明用户没有关注公众号 需要关注
      this.$refs.modal.trigger({ type: 'qr', qrUrl: this.$route.query.qr });
    }
    // 获取code
    if (this.$route.query.code) {
      await this.getDetail(this.$route.query.code);
    } else toast('非法数据');

    if (this.$route.query.mail) {
      this.isFromMail = this.$route.query.mail;
      if (this.isFromMail) {
        this.showMethod1 = true;
      }
    }
  },
  methods: {
    toggleItem(item) {
      // 如果当前项是展开的，直接收起
      if (item.isShow) {
        item.isShow = false;
      } else {
        // 如果当前项是收起的，先收起所有其他项，再展开当前项
        this.detail.detailList.forEach((detailItem) => {
          if (
            detailItem.bookPackageDownloadResourceDetailId !==
            item.bookPackageDownloadResourceDetailId
          ) {
            detailItem.isShow = false;
          }
        });
        item.isShow = true;
      }
    },
    async getDetail(code) {
      loading();
      const res = await booksResourceApi.getDetail(code);
      if (res.code == 200) {
        closeLoading();
        if (res.data) {
          res.data.detailList.map((item, index) => {
            if (index === 0) {
              item.isShow = true;
            } else {
              item.isShow = false;
            }
          });
          this.detail = res.data;
        } else {
          toast('本册资源暂未上传');
        }
      } else toast(res.msg || '请稍后再试或联系管理员');
    },
    async send(item, mail) {
      loading();

      let href = location.href;
      if (!href.includes('mail=')) {
        href += '&mail=true';
      }

      const res = await booksResourceApi.sendMailWithHref({
        bookPackageDownloadResourceId: item.bookPackageDownloadResourceDetailId,
        targetMail: mail,
        href: href,
      });
      if (res.code == 200) {
        this.$refs.modal.trigger({ type: 'send', mail });
        closeLoading();
      } else toast(res.msg || '请稍后再试或联系管理员');
    },
    copy(url) {
      loading();
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', url);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$refs.modal.trigger({ type: 'copy', mail: undefined });
        closeLoading();
      }
      document.body.removeChild(input);
    },
    formatSize,
    async setSafeCode() {
      let params = {
        clientSessionId: sessionStorage.sessionId || setclientSessionId(),
        t: Date.now(),
        client: 'h5',
      };
      params.encrypt = md5(params.client + params.clientSessionId + params.t);
      const res = await api.getSafeCode(params);
      sessionStorage.setItem(
        'safeCode',
        decryptByAES(res.data, '6f0c5ba452b24fa28989e9524d77407a')
      );
    },
    downLoadUrl(url) {
      console.log(url);
      // let blob = new Blob([url]);
      let FileName = 'ceshi' + '.zip';
      let link = document.createElement('a');
      link.href = url;
      link.download = FileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding: 15px 0px;
  user-select: none;
  > div {
    width: 345px;
    margin: 0 auto;
  }
}
.follow {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  padding: 15px;
  img {
    width: 108px;
    height: auto;
  }
  h3 {
    color: #3b3e42;
    margin: 6px 0;
  }
  p {
    color: #999;
  }
  .qrcode {
    width: 94px;
    height: 94px;
  }
}
.method {
  position: relative;
  padding: 15px;
  background: #f5f6f7;
  border-radius: 6px;
  .title {
    color: #3b3e42;
    font-size: 16px;
    font-weight: 500;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    position: relative;
    z-index: 1;
  }
  .desc {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  .float-right {
    font-size: 12px;
    color: #004fff;
    font-weight: 400;
    padding: 2px;
  }
  .bg-icon {
    position: absolute;
    width: 50px;
    height: 50px;
    right: 15px;
    top: 8px;
  }
  .msg {
    margin-top: 10px;
    color: #999;
  }
  .down_new {
    cursor: pointer;
    margin: 10px auto 0;
    text-align: center;
    display: block;
    font-weight: 400;
    padding: 0 10px;
    width: fit-content;
  }
  .down_new.mail {
    line-height: 28px;
    border-radius: 4px;
    border: 1px solid transparent;
    background: #004fff;
    color: #fff;
    border-color: #004fff;
    font-size: 14px;
  }
  .down_new.normal {
    font-size: 12px;
    color: #004fff;
  }
}
.method + .method {
  margin-top: 15px;
}
.down-icon {
  width: 8px;
  // vertical-align: middle;
  transition: all 0.2s linear;
  animation: down 0.1s linear;
}
.overturn {
  transform: rotate(180deg);
}
.input {
  margin-top: 12px;
}
.primary-color {
  color: #004fff;
}
.tips {
  margin-top: 12px;
  font-size: 12px;
  color: #3b3e42;
  font-weight: 500;
  animation: down 0.1s linear;
  p {
    margin-bottom: 12px;
  }
  img {
    width: 100%;
  }
}
@keyframes down {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
.info-title {
  position: relative;
  margin: 5px 0 15px 0;
  .top-wrapper {
    display: flex;
    margin-bottom: 8px;
    height: 50px;
  }
  img {
    width: 42px;
    height: 50px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .info {
    flex: 1;
    display: flex;
    align-items: center;
    .name {
      font-size: 14px;
      color: #3b3e42;
    }
  }
  .bottom-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 18px;
    .size {
      font-size: 12px;
      color: #999999;
    }
  }
  .title-right {
    font-size: 12px;
    color: #004fff;
    font-weight: 400;
    display: flex;
    align-items: center;
    .title-icon {
      width: 8px;
      vertical-align: middle;
      transition: all 0.2s linear;
      animation: down 0.1s linear;
      height: initial;
      margin: 2px 0 0 4px;
    }
  }
}
.detail_item {
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
</style>
